/**
 * Here we import the Router
 */
import { createRouter, createWebHistory, type RouteRecordRaw, type Router } from 'vue-router';

/**
 * Here we import the guards for our routes
 */
import { loginRoutes } from "./routes/login.ts";
import { notFoundRoutes } from "./routes/notFound.ts";
import { homeRoutes } from "./routes/home.ts";
import { testingRoutes } from "./routes/testing.ts";

/**
 * Get all the routes for the router
 */
let routes: RouteRecordRaw[] = [];

routes = routes.concat(
  loginRoutes,
  homeRoutes,
  testingRoutes,
  notFoundRoutes
);

export const router: Router = createRouter({
  history: createWebHistory(),
  routes: routes
});
